export default __webpack_public_path__ + "static/pres_by-4659e58bc2127a8267fc70013d3d5fea.png";